 


<template>
  <v-container >
    <v-row justify="space-around" >
      <v-col cols="12" md="12" >
        <v-dialog
         
          transition="dialog-bottom-transition"
          width="auto"
          :model-value="modelValue"
          @update:modelValue="$emit('update:modelValue', $event)"
        >
          <template v-slot:default="{ isActive }" >
            <v-card  class="pa-13" style=" ">
            
 
                <v-row>
              

                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                        to="/crm/contacts"
                        >
                        <v-icon size="31" class="pb-3">mdi-contacts-outline</v-icon>
                        <p style="font-size: 9px;">Contacts</p>
                        </v-btn>
                    </v-col>



                    
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                        to="/builder"
                     
                        >
                        <v-icon size="31" class="pb-3">mdi-wrench-outline</v-icon>
                        <p style="font-size: 9px;">Site Builder</p>
                        </v-btn>
                    </v-col> 
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                        href="/site"
                        target="_blank"
                        rel="noopener"
                     
                        >
                        <v-icon size="31" class="pb-3">mdi-web</v-icon>
                        <p style="font-size: 9px;">My Site</p>
                        </v-btn>
                    </v-col> 

                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                        to="/marketing/digital"
                        >
                        <v-icon size="31" class="pb-3">mdi-bullhorn-outline</v-icon>
                        <p style="font-size: 9px;">Marketing</p>
                        </v-btn>
                    </v-col>

                    

                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                     
                        >
                        <v-icon size="31" class="pb-3">mdi-cog-outline</v-icon>
                        <p style="font-size: 9px;">Settings</p>
                        </v-btn>
                    </v-col>    
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="isActive.value = false; onSignOut()"
                        >
                        <v-icon size="31" class="pb-3">mdi-power</v-icon>
                        <p style="font-size: 9px;">Logout</p>
                        </v-btn>
                    </v-col>
        
                </v-row>
                            

                    

              <v-card-actions class="justify-end">
                <v-btn
                  text="Close"
                  @click="isActive.value = false"
                ></v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
 
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  modelValue: Boolean,

  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' } 
})

defineEmits(["update:modelValue"])

</script>
